import { memo } from 'react';

import SkipIconSVG from '@/assets/skip-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ISkipIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={SkipIconSVG} {...props} />;

export const SkipIcon = memo(ISkipIcon) as typeof ISkipIcon;
